module.exports = __webpack_public_path__ + "static/handling-emotion-31310d27376402b1a7b6745a8c4ae517.jpg";